// extracted by mini-css-extract-plugin
export default {"yib_left":"index_yib_left_yCfpl","box_list":"index_box_list_ykAUZ","title_04":"index_title_04_weB4L","clearfix":"index_clearfix_fkwme"};